import { useStore, useStoreUI } from '@assets/model/Store';
import { observer } from 'mobx-react';
import Modal from 'react-bootstrap/Modal';
import * as icons from '../NarrativeElement/icons/*.svg';
import * as style from './ModalContainer.module.less';
import { ScrollPanel } from '../Panel/ScrollPanel/ScrollPanel';

export const ModalContainer = observer(() => {
    const store = useStore();
    const uiStore = useStoreUI();
    const modal = uiStore.modal;
    const show = modal != null;
    const el = modal?.el ?? null;
    const sizeParam = modal?.size ?? 'L';
    const sizeLook: Record<typeof modal.size, string> = {
        L: '60vh',
        M: '50vh',
        S: '40vh'
    };
    const modalSizeVh = sizeLook[sizeParam];

    const handleClose = () => {
        uiStore.modal = null;
    };

    const title = uiStore.modal?.title ?? '';
    return (
        <>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title
                        className={style.modalTitle}
                        style={{ flexGrow: 1 }}
                    >
                        {title}
                    </Modal.Title>
                    {uiStore.modal?.onHeaderDelete && (
                        <button
                            type="button"
                            className={style.deleteButton}
                            onClick={uiStore.modal.onHeaderDelete}
                        >
                            <img
                                src={icons['trash']}
                                className={style.deleteIcon}
                            />
                            Delete
                        </button>
                    )}
                </Modal.Header>
                <Modal.Body
                    style={{
                        padding: '10px',
                        height: modalSizeVh
                    }}
                >
                    <ScrollPanel style={{ padding: '10px' }}>{el}</ScrollPanel>
                </Modal.Body>
            </Modal>
        </>
    );
});

export default ModalContainer;
